module.exports = __webpack_public_path__ + "img/seq4.d8a97b6e.png";